<section id="home">

  <div class="menu-btn">Menu</div>

  <nav>
  	<img src="./images/nitt_logo.png" height="86">
  	<img src="./images/NTNU_logo.png" height="56" id="ntnu_logo">
  	<img src="./images/Taltech_logo.png" height="56">
  	<img src="./images/sparc_logo.png" height="56">

    <a href="#home">Home</a>
    <a href="#about">About</a>
    <a href="#dignitaries">Dignitaries</a>
    <a href="#advisory">Advisory Committee</a>
    <a href="#topics">Topics</a>
    <a href="#speakers">Invited speakers</a>
    <a href="#publications">Publication / Proceedings</a>
    <a href="#register">Registration</a>
    <a href="#payment">Payment procedure</a>
    <a href="#submission">Submission / Workflow</a>
    <a href="#auditorium">Venue</a>
    <a href="#contact">Contacts</a>
    <a href="#sponsor">SPONSORSHIP</a>
  </nav>

  <div class="home-content">
    <h1>INTERNATIONAL CONFERENCE ON ADDITIVE MANUFACTURING AND <br/>ALLIED TECHNOLOGIES</h1>
    <h2 class="section-heading">ICAMAT-2022 <br/><span class="date">10 - 11 June 2022</span> <br/>
      <span class="inst">National Institute of Technology Tiruchirappalli • India</span><br/>
      Sponsored by Ministry of Education under SPARC programme.
    </h2>
    <p>
      in association with <br/>
      Norwegian University of Science and Technology, Norway,<br/>
      Tallinn University of Technology, Estonia
    </p>

  </div>
  <div class="hybrid">
    <h2 class="text-center"><span class="animate__flash">Hybrid mode confrence:</span> <br/> ONLINE and OFFLINE presentations</h2>

  </div>
</section>

<script>
	window.onscroll = function() {myFunction()};

function myFunction() {
  if ( document.documentElement.scrollTop > 100) {

    document.getElementsByTagName("nav")[0].className = "nav-scrolled";
    if(!document.getElementById("ntnu_logo").src.endsWith("NTNU_logo_black.png")){
      document.getElementById("ntnu_logo").src = "./images/NTNU_logo_black.png"
    }
  } else {
    document.getElementsByTagName("nav")[0].className = "";
    if(!document.getElementById("ntnu_logo").src.endsWith("NTNU_logo.png")){
      document.getElementById("ntnu_logo").src = "./images/NTNU_logo.png"
    }
  }
}
</script>
<style>
	img {
		float: left;
		padding-left: 8px;
	}
  h1 {
    text-shadow: 2px 2px #ff0000;
  }
  .date {
    text-shadow: 1px 1px #ffff00;
  }
  .inst {
    text-shadow: 1px 1px #00ff00;
  }
  .hybrid {
    position: absolute;
    top: 50%;
    left: 60%;
    width: 30%;
    color: yellow;
    text-shadow: 1px 1px #ffffff;
  }

@-webkit-keyframes flash {
  from,
  50%,
  to {
    opacity: 1;
  }

  25%,
  75% {
    opacity: 0;
  }
}
@keyframes flash {
  from,
  50%,
  to {
    opacity: 1;
  }

  25%,
  75% {
    opacity: 0;
  }
}
.animate__flash {
  animation: flash 2s linear infinite;
}

</style>
